<form [formGroup]="exceptionForm">
	<mat-dialog-content *ngIf="order">
		<div class="title">
			<span translate>{{titleText}}</span>&nbsp;<b><span>
					{{order.customerOrderNumber }}/{{ order.customerOrderItemNumber }}</span></b>&nbsp;
		</div>
		<br>
		<div class="card-content-block-col-4">
			<div class="card-contents-infos">
				<div class="card-content-info">
					<div class="card-content-label" translate>datacenter-filter.cdd</div>
					<div class="card-content-value">
						{{ checkCddWeekData() }}
					</div>
				</div>
			</div>
			<div class="card-contents-infos">
				<div class="card-content-info">
					<div class="card-content-label" translate>datacenter-filter.dimension</div>
					<div class="card-content-value">
						{{ order | copoDimension }}
					</div>
				</div>
			</div>
			<div class="card-contents-infos">
				<div class="card-content-info">
					<div class="card-content-label" translate>datacenter-filter.standard-steel-grade</div>
					<div class="card-content-value">
						{{order| copoModelInfo: 'steelgradeDescription'}}
					</div>
				</div>
			</div>
		</div>
		<div class="copo-grid-row">
			<div class="copo-grid-row-column comment-block">
				<mat-label class="comment-caption" translate>comment.offer.set</mat-label>
				<mat-form-field appearance="outline" class="comment-width">
					<textarea id="comment" rows="4" matInput #comment [cdkTextareaAutosize]="false" maxlength="4000"
						formControlName="comment"></textarea>
					<mat-hint class="copo-textarea-hint" align="end">{{comment.value.length || 0}}/4000</mat-hint>
				</mat-form-field>
				<div class="links" *ngIf="isEditView">
					<button type="button" mat-button (click)="deleteComment()" class="card-info-text-corpo-color underline">Delete
					<mat-icon iconPositionEnd color="accent" svgIcon="md:delete"></mat-icon> </button>
					<button type="button" mat-button (click)="updateView()" class="card-info-text-corpo-color underline">Edit
					<mat-icon iconPositionEnd color="accent" svgIcon="md:edit"></mat-icon> </button>
				</div>
				<span class="warning-text" *ngIf="order.orderItemStatus === '02'" translate>{{warningText}}</span>
			</div>
		</div>
	</mat-dialog-content>

	<mat-dialog-actions align="center">
		<button type="button" mat-button [mat-dialog-close]="false"
			class="save-cancel-button-block copo-button-font">
			<span translate>dashboard.cancel</span>
		</button>
		<button type="button" mat-button class="copo-blue-dark-grey-button" (click)="submitAction()">
			<span translate>{{buttonName}}</span>
		</button>
	</mat-dialog-actions>
</form>